import { connectRequest, getRequestByName } from 'modules/redux-gateway'
import { actions as noticationActions } from 'modules/app-core/notification-manager'
import { MessageListModal } from '../components'
import { selectors, actions, constants } from '../index'

export default connectRequest({
  route: constants.CARRIER_MESSAGES_SEARCH_GET,
  requestOnMountParams: ({ personId, params = {} }) => ({
    EmployeePublicKey: personId || params.id,
  }),
  onFailure: (request, dispatch) => {
    dispatch(
      noticationActions.createNotification({
        type: 'error',
        message: 'Unable to get Message List.',
      })
    )
  },
  onSuccess: (request, dispatch) => {
    dispatch(actions.loadMessageList(request.response))
  },
  mapStateToProps: (state) => {
    const searchReq = getRequestByName(
      state,
      constants.CARRIER_MESSAGES_SEARCH_GET
    )
    const messageReq = getRequestByName(state, constants.CARRIER_MESSAGE_GET)
    return {
      messageList: selectors.getMessages(state),
      message: selectors.getMessage(state),
      isListView: selectors.getIsListView(state),
      isProcessingSearch: searchReq.isProcessing,
      isProcessingMessage: messageReq.isProcessing,
    }
  },
  mapDispatchToProps: (dispatch) => ({
    handleMessageClick: (messageId) => {
      dispatch(actions.getMessage(messageId)).then((message) =>
        dispatch(actions.loadMessage(message))
      )
    },
    handleToggleView: () => {
      dispatch(actions.toggleView())
    },
  }),
})(MessageListModal)
